import React, { useContext } from "react";
import { TextState, Preview } from "@creatomate/preview";
import { useProfile } from "app/context";
import ElementStartEnd from "components/stories/video-studio/common/ElementStartEnd";
import Flip from "components/stories/video-studio/common/properties/Flip";
import LineHeight from "components/stories/video-studio/common/properties/text/LineHeight";
import Rotate from "components/stories/video-studio/common/properties/Rotate";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import { useTemplateBuilder } from "components/admin/templates/context/TemplateBuilderContext";
import DynamicElement from "components/stories/video-studio/common/properties/template-builder/DynamicElement";
import FontEffects from "./FontEffects";
import TextAligment from "./TextAligment";
import TextAreaInput from "./TextAreaInput";
import TextFontValues from "./TextFontValues";

interface TextFieldsProps {
  activeElement: TextState;
  onSelectedEffect: (value: string) => void;
  preview: Preview;
  selectedEffect: string;
}

const TextFields: React.FC<TextFieldsProps> = ({
  activeElement, onSelectedEffect, preview, selectedEffect
}) => {
  const { templateBuilderSelection } = useTemplateBuilder();
  const { data: { mediaType } } = useContext(CreatomateContext);
  const { profile: { organization } } = useProfile();

  return (
    <>
      {templateBuilderSelection !== "none" && (
        <DynamicElement
          activeElement={activeElement}
          preview={preview}
          useDefaultValue
        />
      )}
      <div className="FieldsContainer">
        {mediaType === VIDEO_TYPE && (
          <ElementStartEnd activeElement={activeElement} preview={preview} />
        )}
        <TextAreaInput activeElement={activeElement} preview={preview} />
        <TextFontValues activeElement={activeElement} organization={organization.name || ""} preview={preview} />
        <div className="AlignmentOptions">
          <TextAligment activeElement={activeElement} preview={preview} />
          <LineHeight activeElement={activeElement} preview={preview} />
        </div>
        <FontEffects
          activeElement={activeElement}
          onSelectedEffect={onSelectedEffect}
          organization={organization.name || ""}
          preview={preview}
          selectedEffect={selectedEffect}
        />
      </div>
    </>
  );
};

export default TextFields;
